<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import BagsDesignAPI from "@/services/bags-design-api";
import QrcodeVue from 'qrcode.vue'


export default {
  page: {
    title: "Nos produits",
    meta: [{ name: "description", content: appConfig.description }]
  },
    components: { Layout, QrcodeVue},


    computed:{

      currentIndex() {
        return this.cartItems.findIndex(
          (item) => {
            return item.bagDesignCode === this.bagsDesignCode;
          }
        );
      },

      cartItems() {
        let cart = this.$store.state.cart;
        return  cart && cart.lines ? cart.lines.list : [];
      },

      cartCount() {
        return this.cartItems.length;
      },

      cardStyle() {
        return window.innerWidth <= 768
          ? { minWidth: '858px', minHeight: '858px', borderRadius: '5px' }
          : { borderRadius: '5px' };
      },

      isDraft(){
        return this.selectedModel.status == 0
      },

      itemsByBagsDesignCode() {
        if(this.isDraft){
          return this.cartItems.filter(item => item.bagDesignCode === this.bagsDesignCode)[0]
        }
        return this.bagDesignResponse && this.bagDesignResponse.lines && this.bagDesignResponse.lines.list.length > 0 ? this.bagDesignResponse.lines.list[0] : null;
      },

    },

  data() {
    return {
      modelKey: 0,
      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight,
      position:null,
      selectedModel: { bagsDesignObjects: null, cartId: null},
      bagsDesignCode: null,
      defaultImageTinteColor:null,
      item:null,
      isTextInput:false,
      selectedQuantities: {},
      selectedImage: null,
      submissionDate:null,
      orderRef:null,
      bagDesignResponse:null,
      visibleAttributeIndex:0,
      currentQuantityindex:0,
      paperTypindex:0,
      paperColorindex:0,
      requestedPaperTypeUnavailableMessage:null,
      GOLD_COLOR: '#d3aa7c',
      WHITE_COLOR: '#FFFFFF'
    }
  },

  watch: {

    '$route': {
            immediate: true,
            deep: true, 
            handler(route) {
              this.bagsDesignCode = route.params.code;
              this.getBagDesignByCode();

            }
        },

    screenWidth() {
      if(window.innerWidth > 768){
        this.modelKey++
      }
    },
  },

  mounted() {
    this.paperTypindex++

    window.addEventListener("resize", this.updateScreenSize);
    document.querySelector('.main-content').style.overflow = 'visible';

  },


  beforeUnmount() {
    window.removeEventListener("resize", this.updateScreenSize);
  },

  methods:{
    checkAvailablePaperType(paperType){
      this.requestedPaperTypeUnavailableMessage = null;
      let variant = this.itemsByBagsDesignCode.variants[0]
      const unavailable = [];
      const type = paperType === 0 ? 'Kraft' : 'ingraissable';
      const otherType = paperType === 0 ? 'ingraissable' : 'Kraft';

      if (paperType === 0) {
          if (variant.isKraft === false) {
            unavailable.push(variant.title);
          }
      } else if (paperType === 1) {
          if (variant.isAntiGraisse === false) {
            unavailable.push(variant.title);
          }
      }

      if (!unavailable || unavailable.length === 0){
         this.requestedPaperTypeUnavailableMessage = '';
         return true;
      } 
      this.requestedPaperTypeUnavailableMessage =`<span>Le papier ${type} n’est pas disponible pour <strong>${variant.title}.</strong> ` +
           `Le papier ${otherType} sera utilisé pour ce type de sac.</span>`;
      
      return false;
      
    },
    printPage() {
      window.scrollTo({top: 0,left: 0,behavior: 'smooth'});
      setTimeout(() => {
        window.print();
      }, 100);
    },

  downloadLogoOrQrCode(zone){
    if(zone.type == 2 && zone.isEnabledPersonalisedQrCode && zone.text != null && zone.text.trim() !== ''){
        this.downloadPersonalisedQrCode(zone);
    }else if (zone.type == 1 && zone.contentType !=1 && zone.image != null ){
      this.downloadImage(zone);
    }
  },
    downloadImage(zone) {
      let url = '';
      if (zone.contentType === 2 && !zone.mask) {
        url = `${zone.image}`;
      } else {
        const rgb = zone.mask || this.defaultImageTinteColor;
        url = `tinted/${zone.image}?rgb=${rgb}`;
      }

      BagsDesignAPI.downloadLogo(zone.image, url);
    },

  downloadPersonalisedQrCode(zone){
    const canvas = this.$el.querySelector(`#qr-code-${zone.id} canvas`);
    if (canvas) {
      const dataUrl = canvas.toDataURL("image/png");

      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = `QRCode-${zone.name || 'custom'}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  },

  getBagDesignByCode(){
    BagsDesignAPI.getBagDesignByCode(this.bagsDesignCode).then((result) => {
          if(result){
            this.bagDesignResponse = result
            this.selectedModel = this.bagDesignResponse.bagsDesignDTO
            this.submissionDate= this.bagDesignResponse.submissionDate
            this.orderRef= this.bagDesignResponse.orderRef

            this.defaultImageTinteColor = this.selectedModel.possibleColors[0]
            this.setTransparentColorForObject()
          }else{
            this.$router.push({ name: "404" });
          }
        }
      )

  },
  
  sendStylesToBackend(/*otherDesignIndex*/) {
  this.selectedModel.code = this.bagsDesignCode;
  BagsDesignAPI.saveBagDesign(this.selectedModel).then((result) => {
    if (result) {
      this.requestedPaperTypeUnavailableMessage = '';
      this.$store.dispatch('fetchCart');
      this.$root.$emit('bv::toggle::collapse', 'sidebar-backdrop');
     // this.handleNavigationAfterSave(otherDesignIndex)
    }
  });
  this.visibleAttributeIndex =0
},

  handleNavigationAfterSave(otherDesignIndex) {
    if (otherDesignIndex === 1 && this.currentIndex === this.cartCount - 1) {
      this.$store.dispatch('fetchCart');
      this.$root.$emit('bv::toggle::collapse', 'sidebar-backdrop');
      return;
    }

    if (this.currentIndex !== -1) {
      let newIndex = this.currentIndex;
      if (otherDesignIndex === 0 && this.currentIndex > 0) {
        newIndex = this.currentIndex - 1;
      } else if (otherDesignIndex !== 0 && this.currentIndex < this.cartItems.length - 1) {
        newIndex = this.currentIndex + 1;
      }

      const nextBagDesignCode = this.cartItems[newIndex].bagDesignCode;
      this.$router.push({ path: '/personnalisation-produit/' + nextBagDesignCode });
    }
  },


  onDragCallback(zone, x, y){
    zone.xPosition = x,
    zone.yPosition = y

  },

  onResizeCallback(zone, ...$event){

    // const resizing = true;
    const x = $event[0];
    const y = $event[1];
    const width = $event[2];
    const height = $event[3];

    zone.xPosition = x,
    zone.yPosition = y,
    zone.widthImage = width,
    zone.heightImage = height

  },


    convertToResponsiveSize(value, type) {

      if (typeof value === "string" && value.includes("%")) {

          const parentSize = type === "width" ? 1059 : 731;
          const result = (parseFloat(value) / 100) * parentSize + "px";

          return result;
      }

      const result = type === "width"
        ? `${(value / this.screenWidth) * 100}vw`
        : `${(value / this.screenHeight) * 100}vh`;

      return result;
    },

    updateScreenSize() {
      this.screenWidth = window.innerWidth;
      this.screenHeight = window.innerHeight;
    },

    convertToPx(value, type) {

      if (typeof value === "string" && value.includes("%")) {

        const parentSize = type === "width" ? 1059 : 731;
        return (parseFloat(value) / 100) * parentSize;
      }
      return value; 
    },

    handleFileUpload(event, zone) {
      const file = event.target.files[0];
      if (file) {
        this.uploadImage(zone, file)
      }
      this.modelKey++
    },

    uploadImage(zone, file){
      const fd = new FormData();
      fd.append('file', file)
      BagsDesignAPI.uploadImage(fd).then(
        res => {
          if(res){
            zone.image=res
            zone.mask = this.selectedModel.possibleColors[0]
            this.modelKey++
          }
        }
      )
    },


    selectPaperType(paperType){
      if(this.checkAvailablePaperType(paperType)){
        this.$store.dispatch('addToCart', [{ itemVariantId: this.itemsByBagsDesignCode.variants[0].id, quantity: 0 , paperType:paperType != null ? paperType :  null , paperColor : this.itemsByBagsDesignCode.paperColorValue != null ? this.itemsByBagsDesignCode.paperColorValue :  null   }])
        .finally(()=>{
          this.paperTypindex++
        })
      }
    },
    selectPaperColor(paperColor){
      this.$store.dispatch('addToCart', [{ itemVariantId: this.itemsByBagsDesignCode.variants[0].id, quantity: 0 , paperType:this.itemsByBagsDesignCode.paperTypeValue != null ? this.itemsByBagsDesignCode.paperTypeValue :  null , paperColor:paperColor != null ? paperColor :  null }])
      .finally(()=>{
        this.paperColorindex++
        this.setTransparentColorForObject()
      })
    },

    setTransparentColorForObject(){

      if (!this.selectedModel || !this.selectedModel.bagsDesignObjects || !this.selectedModel.bagsDesignObjects.length) {
        return;
      }

      this.selectedModel.bagsDesignObjects.forEach(zone => {
          if(zone.isTransparentColor) {
            zone.fontColor = (this.itemsByBagsDesignCode?.paperColorValue === 0)
              ? this.GOLD_COLOR
              : this.WHITE_COLOR;
          } else if (!zone.fontColor) {
            zone.fontColor = `#${this.selectedModel.possibleColors[0]}`;
          }
        });
      
    },

    updateQuantity(variant , newValue) {

      const quantity = parseInt(newValue, 10);
      if (variant && variant.id && !isNaN(quantity)) {
          const newQuantity = quantity - variant.cartItemQuantity
          if(newQuantity == 0){
            return
          }
          this.$store.dispatch('addToCart', [{ itemVariantId: variant.id, quantity: newQuantity}]).finally(()=>{
                this.currentQuantityindex++
             })

      }
    },

    nextAttribute(){
      if(this.visibleAttributeIndex < this.selectedModel.bagsDesignObjects.length - 1){
        this.visibleAttributeIndex++
      }else{
        this.visibleAttributeIndex = 0
      }
    },

    previousAttribute(){
      if(this.visibleAttributeIndex > 0){
        this.visibleAttributeIndex--
      }else{
        this.visibleAttributeIndex = this.selectedModel.bagsDesignObjects.length - 1
      }
    }

  }

};
</script>

<template>
  <Layout>
    <div v-if="(cartCount && cartCount > 0 ) || (selectedModel && (selectedModel.status == 1 || selectedModel.status == 0 )) " class="p-4" style="background:#f8f7fa;">
             
      <div class="row  w-100 mb-3 mt-3 mb-5">
        
        <div class="col-12 text-uppercase  text-center mt-md-3 mt-0 mb-md-3 mt-0 d-print-none" v-if="isDraft">
            <h1 class="font-size-24 font-weight-bold text-dark ">Outil de Personnalisation</h1>
        </div>
        <div class="col-12 text-uppercase  text-center mt-md-3 mt-0 mb-md-3 mt-0 " v-else>
            <h1 class="font-size-24 font-weight-bold text-dark  ">Commande N° {{orderRef}}  du {{submissionDate}} </h1>
            <h2  v-if="itemsByBagsDesignCode" class="font-size-20 font-weight-bold text-dark  "> {{itemsByBagsDesignCode.title}} <small>({{itemsByBagsDesignCode.variants[0].title}} | REF: {{ itemsByBagsDesignCode.ref }} )</small>  </h2>
        </div>


        <!-- <div class="col-6 d-print-none" v-if="isDraft">
          <b-button
            v-if="cartCount > 1"
            variant="dark"
            size="md"
            @click="sendStylesToBackend(0)"
            class="text-uppercase custom-rounded font-weight-bold"
            :disabled="currentIndex == 0"
            >
              <img  alt="" width="20px"
                style="cursor: pointer; transform: scaleX(-1);" 
                src="@/assets/icons/arrow-next.svg"
                class="pl-1 pb-1"/>
              Précédent
          </b-button>
        </div> -->

        <div class="col-12 text-right d-print-none"  v-if="isDraft" >
          <b-button
            variant="dark"
            size="md"
            @click="sendStylesToBackend(1)"
            class="text-uppercase custom-rounded font-weight-bold"
          > Enregistrer
            <!-- <img  alt="" width="20px"
              style="cursor: pointer;" 
              src="@/assets/icons/arrow-next.svg"
              class="pl-1 pb-1"/>  -->
          </b-button>
        </div>
        <div v-else class="col-12 p-1 float-right d-print-none" > 
          <a href="javascript:window.print()">
              <b-button variant="secondary" class="float-right" >
                <img  alt="" width="16px"
                  style="cursor: pointer;" 
                  src="@/assets/icons/print-white.svg"
                  class="mr-2"/> Imprimer
              </b-button>
            </a>
        </div>



    </div>


      <div class="row">

        <div class="col-md-4 col-12 pr-md-2 d-print-none" >
          <div>
            <div v-if="selectedModel &&  selectedModel.bagsDesignObjects && selectedModel.bagsDesignObjects.length > 0" >
              <div class="card mb-3 position-relative d-print-none" v-if="itemsByBagsDesignCode &&   itemsByBagsDesignCode.variants && itemsByBagsDesignCode.variants.length > 0">
                <div class="card-body">
                  <div class="row">
                    <div v-if="itemsByBagsDesignCode.mainImage" class="col-xl-2 col-md-3 col-sm-1 col-2 ">
                      <img :src="'/api/image/get/' + itemsByBagsDesignCode.mainImage" 
                        alt="Image du produit" 
                        class="rounded me-4 mb-3 mb-md-0" 
                        style="width: 100%; height: auto; max-width: 100px; min-width: 50px;" />

                    </div>
                    <div class="col-xl-10 col-md-9 col-sm-11 col-10  p-2">

                      <div class="row">
                        <div class="col-lg-8 col-md-12 col-sm-6 col-12 pr-md-2 pr-sm-0 pl-sm-0 pl-xs-2 " >
                          <div v-if="isDraft" >
                             <h5 class="text-dark font-weight-bold mb-2 d-inline">{{ itemsByBagsDesignCode.title }}</h5>
                              <div class=" mt-1"> 
                                <span class="text-dark font-weight-bold">{{ itemsByBagsDesignCode.variants[0].title }}</span>
                              </div>
                              <div><small class="text-secondary font-weight-bold">REF: {{ itemsByBagsDesignCode.ref }}</small></div>
                          </div>
                          <div v-else>
                              <h5 class="text-dark font-weight-bold mb-2 d-inline">{{ itemsByBagsDesignCode.title }}</h5>
                              <div class="text-secondary font-weight-bold pl-1 mt-1">Papier {{ itemsByBagsDesignCode.paperTypeValue === 0 ? 'KRAFT' : 'INGRAISSABLE' }}</div>
                              <div class="text-secondary font-weight-bold pl-1">{{ itemsByBagsDesignCode.variants[0].cartItemQuantity }} Sacs Commandée</div>
                              <div class="text-secondary font-weight-bold pl-1">{{ itemsByBagsDesignCode.variants[0].cartItemSubTotal }}</div>
                          </div>
                         

                        </div>

                       
                      </div>
                    </div>
                  </div>






                  

                    <div class="row text-dark mt-4 mb-4" v-if="isDraft">
                      <div  class="col-12  text-danger font-size-14 pr-4" v-html="requestedPaperTypeUnavailableMessage"></div>

                      <div  class="col-12 col-sm-6 col-md-12 col-xl-6 d-flex flex-column justify-content-start">
                        <!-- paper Type  -->
                        <div :key="paperTypindex" v-if="itemsByBagsDesignCode.paperTypeValue != null && itemsByBagsDesignCode.supportedAntiGraisse">
                          <div class="d-flex mt-2">
                            <div class="d-flex justify-content-center justify-content-end mb-2 mb-md-0 h-100">
                              <b-button size="md" variant="outline-secondary"  @click="selectPaperType(0)"
                                :class="{ selected: itemsByBagsDesignCode.paperTypeValue === 0 }"
                                class=" font-size-10 paperTypeButton custom-right-rounded font-weight-bold">KRAFT
                              </b-button>
                            </div>
                            <div class="d-flex justify-content-center justify-content-start h-100">
                              <b-button size="md" variant="outline-secondary"  @click="selectPaperType(1)"
                                :class="{ selected: itemsByBagsDesignCode.paperTypeValue === 1 }"
                                class="font-size-10 paperTypeButton custom-left-rounded font-weight-bold">INGRAISSABLE
                              </b-button>
                            </div>
                          </div>
                        </div>
                        <!-- paper Color -->
                        <div :key="paperColorindex" v-if="itemsByBagsDesignCode.paperColorValue != null">
                          <div class="d-flex  mt-2">
                            <div class="d-flex justify-content-center justify-content-md-end mb-2 mb-md-0 h-100">
                              <b-button size="md" variant="outline-secondary"  @click="selectPaperColor(0)"
                                :class="{ selected: itemsByBagsDesignCode.paperColorValue === 0 }"
                                class=" font-size-10 paperTypeButton custom-right-rounded font-weight-bold">Brun
                              </b-button>
                            </div>
                            <div class="d-flex justify-content-center justify-content-md-start h-100">
                              <b-button size="md" variant="outline-secondary"  @click="selectPaperColor(1)"
                                :class="{ selected: itemsByBagsDesignCode.paperColorValue === 1 }"
                                class="font-size-10 paperTypeButton custom-left-rounded font-weight-bold">Blanc
                              </b-button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-12 col-sm-6 col-md-12 col-xl-6  d-flex flex-column align-items-start align-items-sm-end align-items-md-start  align-items-xl-end">
                        <div class="d-flex align-items-center mt-2 overflow-hidden rounded-lg " style="    max-width: 110px; border:1px solid #ddd; border-top:1px solid #ddd;">
                              
                          <input
                            ref="quantityInput01"
                            class="quantity-input w-20 text-center py-2 outline-none text-dark font-weight-bold    " 
                            type="number"
                            :key="currentQuantityindex"
                            :value="itemsByBagsDesignCode.variants[0].cartItemQuantity"
                            :min="itemsByBagsDesignCode.variants[0].minQuantityOrdered"
                            @keyup.enter="updateQuantity(itemsByBagsDesignCode.variants[0], $event.target.value)"
                          />
                            <b-button variant="light" class="pr-1 pl-1 float-right" @click="updateQuantity(itemsByBagsDesignCode.variants[0], $refs.quantityInput01.value)" style="border-radius:0px">
                            <img :src="require('@/assets/icons/cart-valid.svg')" alt="save" class="save-svg" />
                            </b-button>
                        </div>
                        <div class="quantity-subtotal  mt-2 mt-0  text-dark ">{{ itemsByBagsDesignCode.variants[0].cartItemSubTotal }}</div>
                      </div>
                    </div>





                 

                  <div class="mt-2 ml-2 text-secondary text-justify mt-1 " style="font-size: 13px;">{{ itemsByBagsDesignCode.description }}</div>

                  <div class="text-secondary font-weight-bold mt-3 ml-2 d-flex align-items-center text-justify">
                    NB : Les couleurs peuvent légèrement différer de celles affichées à l’écran en raison du processus d'impression.
                  </div>

                  <div class="text-secondary mt-3 ml-2 font-weight-bold text-justify" v-if="itemsByBagsDesignCode.paperTypeValue != null && itemsByBagsDesignCode.paperTypeValue  ===0">
                    {{ $t("userMessage.colorRecommendation.title") }} {{ $t("userMessage.colorRecommendation.label") }}
                  </div>
                  <div class="ml-2 mt-4">
                    

                    <div class="text-secondary mt-2 d-flex align-items-center">
                      <img alt="box" width="20px" class="mr-2" src="@/assets/icons/box-svgrepo-com.svg" />
                      <span class="text-dark font-size-14"> <span class="font-weight-bold text-dark mr-3"> Minimum de commande </span>{{ itemsByBagsDesignCode.variants[0].minQuantityOrdered }} Sacs / Commande</span>
                    </div>

                    <div class="mt-2 d-flex align-items-center text-secondary font-size-12 flex-wrap">
                      <div class="d-flex flex-wrap align-items-center">
                        <img alt="tags" width="20px" class="mr-2" src="@/assets/icons/tags-svgrepo-com.svg" />
                        <div class="font-weight-bold text-dark mt-0 font-size-14">Prix selon quantités commandées</div>
                        <div class="row w-100">
                          <div
                            v-for="(tier, index) in itemsByBagsDesignCode.variants[0].priceTiers"
                            :key="index"
                            class="pl-2 mt-2 col-12 text-dark font-size-14  "
                          >
                            {{ tier.priceAsString }} / {{ tier.quantity }} Sacs
                        </div>
                      </div>
                      </div>
                    </div>

                   

                  </div>
                </div>
              </div>




                <div v-for="(zone, index) in selectedModel.bagsDesignObjects" :key="index" class="d-print-none">
                  <div class="mb-4" >
                    <div class="zone-fields p-3 ">



                      <div class="row">

                        <div class="col-8">
                          <div class="form-label h5 text-dark font-weight-bold text-uppercase mb-4 pb-2 ">{{ zone.name }}
                            <b-button variant="outline-light" size="sm" class="ml-2" v-if="(zone.type == 1 && zone.contentType !=1 && zone.image != null ) || (zone.type == 2 && zone.isEnabledPersonalisedQrCode && zone.text != null && zone.text.trim() !== '')" 
                                @click="downloadLogoOrQrCode(zone)">
                                <img alt="tags" width="18px" class="mr-2" src="@/assets/icons/download.svg" /> Télécharger
                            </b-button>     
                          </div> 
    
                        </div>


                        <!-- <div class="col-4 text-right">
                           <b-button
                            variant="outline-light" size="sm"
                            @click="previousAttribute" class="text-uppercase custom-rounded font-weight-bold">
                            
                            <i class="fas fa-angle-left font-size-16"></i>
                            
                          </b-button>

                          <b-button
                            variant="outline-light" size="sm"
                            @click="nextAttribute" class="text-uppercase custom-rounded font-weight-bold ml-2 " >
                            
                            <i class="fas fa-angle-right font-size-16"></i>
                          </b-button>
                        </div> -->

                      </div>


                      <div v-if="zone.type === 1" class="mt-3">
                        <div class="form-group">
                          <label class="font-weight-bold mb-2">Choisir le type de personnalisation :</label>
                          <div class="d-flex flex-wrap gap-3">
                            <div class="form-check form-check-inline">
                              <input
                                :disabled="!isDraft"
                                class="form-check-input"
                                type="radio"
                                :id="`radioImage-${index}`"
                                :name="`contentType-${index}`"
                                :value="0"
                                v-model="zone.contentType"
                                @change="zone.image = null; zone.text = null"
                              />
                              <label class="form-check-label" :for="`radioImage-${index}`">Logo image</label>
                            </div>

                            <div class="form-check form-check-inline">
                              <input
                                :disabled="!isDraft"
                                class="form-check-input"
                                type="radio"
                                :id="`radioText-${index}`"
                                :name="`contentType-${index}`"
                                :value="1"
                                v-model="zone.contentType"
                                @change="zone.image = null"
                              />
                              <label class="form-check-label" :for="`radioText-${index}`">Logo textuel</label>
                            </div>

                            <div class="form-check form-check-inline">
                              <input
                                :disabled="!isDraft"
                                class="form-check-input"
                                type="radio"
                                :id="`radioPredefined-${index}`"
                                :name="`contentType-${index}`"
                                :value="2"
                                v-model="zone.contentType"
                                @change="zone.image = null ; zone.text = null ;zone.mask = null "
                              />
                              <label class="form-check-label" :for="`radioPredefined-${index}`">Image prédéfinie</label>
                            </div>
                          </div>
                        </div>
                      </div>



                      <div v-if="zone.type === 1 && zone.contentType === 2" class="mt-3 mb-3">
                        <div class="d-flex justify-content-between flex-wrap">
                          <div
                            v-for="(defaultImage, index) in selectedModel.defaultImages"
                            :key="index"
                            :class="['image-wrapper', { selected: zone.image === defaultImage }]"
                            @click="isDraft ? zone.image = defaultImage : ''"
                          >
                            <img v-bind:src="'/api/image/get/' + defaultImage" alt="" height="30"  />
                          </div>
                        </div>
                      </div>


                      <!-- <div v-else> -->
                        <div class="row align-items-end mb-2 ">

                            <div class="d-flex mt-3">
                              <span v-if="zone.type === 0 || (zone.type === 1 && zone.contentType === 1)" class="btn-group shadow-sm rounded-3">
                                  <button
                                    :disabled="!isDraft"
                                    style="height: 2.2rem;"
                                    class="btn btn-sm btn-icon"
                                    :class="zone.textAlign === 'left' ? 'btn-dark active' : 'btn-outline-dark'"
                                    @click="zone.textAlign = 'left'"
                                  >
                                    <img  alt="" width="15px"
                                      style="cursor: pointer;" 
                                      src="@/assets/icons/align-left.svg"/> 
                                  </button>
                                  <button
                                  :disabled="!isDraft"
                                    class="btn btn-sm btn-icon"
                                    :class="zone.textAlign === 'center' ? 'btn-dark active' : 'btn-outline-dark'"
                                    @click="zone.textAlign = 'center'"
                                  >
                                    <img  alt="" width="14px"
                                      style="cursor: pointer;" 
                                      src="@/assets/icons/align-center.svg"/>
                                  </button>
                                  <button
                                  :disabled="!isDraft"
                                    class="btn btn-sm btn-icon"
                                    :class="zone.textAlign === 'right' ? 'btn-dark active' : 'btn-outline-dark'"
                                    @click="zone.textAlign = 'right'"
                                  >
                                    <img  alt="" width="15px"
                                      style="cursor: pointer;" 
                                      src="@/assets/icons/align-right.svg"/>
                                  </button>
                                </span>
                            </div>

                          <div v-if="zone.type === 2" class="col-12 custom-control custom-switch mb-3">
                            <input
                            :disabled="!isDraft"
                              type="checkbox"
                              class="custom-control-input"
                              id="toggleEnabledQr"
                              v-model="zone.isEnabledPersonalisedQrCode"
                            />
                            <label class="custom-control-label" for="toggleEnabledQr" :class="zone.isEnabledPersonalisedQrCode ? 'text-primary': '' ">
                              Activer code QR personnalisé au dos du sac
                            </label>
                          </div>

                          <div class="col-12 col-sm-6 col-md-12 col-xl-7   d-flex align-items-center mt-2   pl-0   pl-sm-2  pl-md-0   pl-xl-2  
                                      mt-2   mt-sm-2  mt-md-2   mt-xl-0 "
                              :class="zone.type === 0 || (zone.type === 1 && zone.contentType === 1)? ' pl-0   pl-sm-4  pl-md-0   pl-xl-4 ' :''">

                                      
                            <div class="d-flex">
                              <span v-if="zone.type === 0 || (zone.type === 1 && zone.contentType === 1)" class="btn-group shadow-sm rounded-3">
                                <button
                                  :disabled="!isDraft"
                                  style="height: 2.2rem;"
                                  class="btn btn-sm"
                                  :class="zone.fontWeight === 'normal' ? 'btn-icon btn-dark active' : 'btn-icon btn-outline-dark'"
                                  @click="zone.fontWeight = 'normal'"
                                  >
                                  <img  alt="" width="18px"
                                      style="cursor: pointer;" 
                                      src="@/assets/icons/font.svg"
                                      class="pr-1 pb-1"/>
                                <strong>Normal</strong>
                              </button>
                              <button
                                :disabled="!isDraft"
                                class="btn btn-sm"
                                :class="zone.fontWeight === 'bold' ? 'btn-icon btn-dark active' : 'btn-icon btn-outline-dark'"
                                @click="zone.fontWeight = 'bold'"
                                >
                                <img  alt="" width="15px"
                                  style="cursor: pointer;" 
                                  src="@/assets/icons/bold.svg"
                                  class="pr-1 pb-1"/>
                                <strong>Gras</strong>
                              </button>
                              </span>

                              <div v-if="!zone.isTransparentColor" >
                                <div v-if="zone.type === 1 && zone.contentType !== 1 && !zone.isTransparentColor "  class="d-flex align-items-center mr-2">
                                  <span
                                    v-for="(color, index) in selectedModel.possibleColors"
                                    :key="index"
                                    @click="isDraft ?  zone.contentType  == 2 && zone.mask && zone.mask === color  ? zone.mask = null :  zone.mask = color : ''"
                                    class="border mr-2 d-flex align-items-center justify-content-center"
                                    :class="['color-box', { selected: zone.mask === color }]"
                                    :style="{ borderColor: color }"
                                    :title="color"
                                  >
                                    <span
                                      :style="{ backgroundColor: `#${color}` }"
                                      style="
                                        width: 100%;
                                        height: 100%;
                                        border-radius: 2px;
                                        cursor: pointer;"
                                    ></span>
                                  </span>
                                </div>
                                <div v-else class="d-flex align-items-center " :class="zone.type === 0 || (zone.type === 1 && (zone.contentType === 1 || zone.contentType === 2))? 'pl-4' :'' ">
                                  <span
                                    v-for="(color, index) in selectedModel.possibleColors"
                                    :key="index"
                                    @click="isDraft ? zone.fontColor = `#${color}` : ''"
                                    class="border mr-2 d-flex align-items-center justify-content-center"
                                    :class="['color-box', { selected: zone.fontColor === `#${color}` }]"
                                    :style="{ borderColor: color }"
                                    :title="color"
                                  >
                                    <span
                                    :style="{ backgroundColor: `#${color}` }"
                                    style="
                                        width: 100%;
                                        height: 100%;
                                        border-radius: 2px;
                                        cursor: pointer;"
                                    ></span>
                                  </span>
                                </div>
                              </div>


                            </div>

                          </div>

                          <div v-if="zone.type === 0 || (zone.type === 1 && zone.contentType === 1)" class="mt-3 col-12 col-sm-6 col-md-12 col-xl-5 d-flex align-items-center ">
                            <v-select
                            :disabled="!isDraft"
                              style="font-size:1.1em; width: 100%; height: 2.2rem;" class="text-dark"
                              placeholder="Polices"
                              :options="[
                                  { label: 'Arial', value: 'Arial, sans-serif' },
                                  { label: 'Courier New', value: 'Courier New, monospace' },
                                  { label: 'Georgia', value: 'Georgia, serif' },
                                  { label: 'Times New Roman', value: 'Times New Roman, serif' },
                                  { label: 'Fantasy', value: 'fantasy, serif' },
                                  { label: 'Monospace', value: 'monospace' },
                                  { label: 'Cursive', value: 'cursive' }
                                ]"
                                v-model="zone.fontFamily"
                                :reduce="option => option.value"
                                
                            />
                          </div>



                          <!-- Font Size -->
                          <div v-if="zone.type === 0 || (zone.type === 1 && zone.contentType === 1)" class="col-12 d-flex align-items-center pr-2 mt-4">
                            <div class="d-flex align-items-center w-100">
                              <input
                              :disabled="!isDraft"
                              type="range" class="w-100"
                              min="50"
                              max="150"
                              step="1"
                              v-model="zone.fontSize"
                              style="accent-color: #000;"
                              />
                              <span class="ml-2" style="font-size: 1.2em;">{{ zone.fontSize || 100 }}</span>
                            </div>
                          </div>


                        </div>

                        <div v-if="zone.type === 1 && zone.contentType === 1">
                          <div>
                            <label class="form-label font-size-16 mt-4 text-dark fw-medium">Champ personnalisé</label>
                            <input
                            :disabled="!isDraft"
                              type="text"
                              class="form-control form-control-lg shadow-sm rounded-3 text-primary font-weight-bold"
                              :id="zone.name"
                              v-model="zone.text"
                              :style="{
                                height: '2.2rem',
                                fontFamily: zone.fontFamily
                              }"
                              placeholder="Saisissez votre text personnalisé"
                            />
                          </div>
                        </div>

                        <div  v-else-if="zone.type === 1 && zone.contentType === 0" >
                          <small class="form-text text-muted mt-2">Télécharger une image pour cette zone</small>
                          <div class="custom-file ">
                            <input
                            :disabled="!isDraft"
                              type="file"
                              class="custom-file-input"
                              :id="zone.name"
                              @change="handleFileUpload($event, zone)"
                              accept="image/png"
                            />
                            <label class="custom-file-label" :for="zone.name">
                              <img  alt="" width="14px"
                                src="@/assets/icons/upload.svg"
                                class="mr-2 pb-1"/> choisir image
                            </label>
                          </div>
                        </div>


                       

                        <!-- Text Input -->
                        <div v-if="zone.type === 0 || zone.type == 2">
                          <label class="form-label font-size-16 mt-4 text-dark fw-medium">{{ zone.type === 0 ? 'Entrez le texte' :'Entrez le contenu du code QR' }}</label>
                          <input
                            :disabled="!isDraft || (zone.type == 2 && !zone.isEnabledPersonalisedQrCode)"
                            type="text"
                            class="form-control form-control-lg shadow-sm rounded-3 text-primary font-weight-bold"
                            :id="zone.name"
                            v-model="zone.text"
                            :style="{
                              height: '2.2rem',
                              fontFamily: zone.fontFamily
                            }"
                            :placeholder="'Saisissez votre ' + zone.name"
                          />
                        </div>
                      <!-- </div> -->
                    </div>
                  </div>
                 </div>

                
            </div>
          </div>

        </div >
        <div class="col-md-8 col-12 pl-md-2" >

          <div class="modelDesign text-center mt-md-0 mt-2  table-responsive border-custom position-sticky mt-4" :style="{ backgroundColor: itemsByBagsDesignCode && itemsByBagsDesignCode.paperColorValue === 0 ? GOLD_COLOR : WHITE_COLOR }">

            <div :key="modelKey" class="card ml-md-0 ml-0"  style="box-shadow: 0 0 0 !important ;"  :style="cardStyle"
            >
              <div class="card-body " :style="{ backgroundColor: itemsByBagsDesignCode && itemsByBagsDesignCode.paperColorValue === 0 ? GOLD_COLOR : WHITE_COLOR }">
                <div v-if=" selectedModel" class="image-container p-1">

                    <img v-if="selectedModel.image"  v-bind:src="'/api/image/get/' +  selectedModel.image" class="image" />

                    <div
                      v-for="(zone, index) in selectedModel.bagsDesignObjects"
                      :key="index"
                      :class="zone.image || zone.text
                                ? 'custom-zone zone'
                                : (zone.type != 2
                                    ?     (  visibleAttributeIndex == index ? 'custom-empty-zone-selected zone d-print-none' : 'custom-empty-zone zone d-print-none' )
                                    : (zone.type == 2 && zone.isEnabledPersonalisedQrCode
                                        ? (  visibleAttributeIndex == index ? 'custom-empty-zone-selected zone d-print-none' : 'custom-empty-zone zone d-print-none' )
                                        : 'd-none'
                                      )
                                  )"
                      :style="` 
                        display: flex;
                        justify-content: ${zone.textAlign};
                        align-items: center;
                        top: ${zone.topZone} !important;
                        left: ${zone.leftZone} !important;
                        width: ${zone.widthZone} !important;
                        height: ${zone.heightZone} !important;
                        font-size: ${zone.fontSize ? zone.fontSize : '100' }% !important;
                        font-weight: ${zone.fontWeight  ? zone.fontWeight : 'normal'} !important;
                        color: ${zone.fontColor  ? zone.fontColor : '#000'} !important;
                        font-family: ${zone.fontFamily ? zone.fontFamily : 'none'} !important;
                        border-radius: ${zone.radius}% !important;
                      `"
                    >

                    <div v-if="zone.image || zone.text">
                      <div :style="`
                            width: ${zone.image ? convertToResponsiveSize(zone.widthZone, 'width') : zone.text ? '' :'100'} !important;
                            height: ${zone.image ? convertToResponsiveSize(zone.heightZone, 'height') : zone.text ? '' : '100'} !important;
                            overflow: hidden !important;
                            border-radius: ${zone.contentType && zone.contentType === 1 ? '0' : zone.radius}% !important;
                          `">

                      <vue-draggable-resizable v-if="zone.image && zone.type == 1"
                        class-name="draggableResizable" 
                        :parent="true"
                        :x="zone.xPosition" :y="zone.yPosition"
                        :w="zone.widthImage &&  zone.widthImage > 0 ? zone.widthImage : convertToPx(zone.heightZone, 'width')" 
                        :h="zone.heightImage && zone.heightImage > 0 ? zone.heightImage  :convertToPx(zone.heightZone, 'height') " 
                        @dragging="(x, y) => onDragCallback(zone, x, y)"
                        @resizing="(...event ) => onResizeCallback(zone, ...event)" >
                        
                        <img v-if="zone.contentType == 2 && !zone.mask" class="zone-image" v-bind:src="`/api/image/get/${zone.image}`"                        />
                        <img v-else class="zone-image" v-bind:src="`/api/image/get/tinted/${zone.image}?rgb=${zone.mask || defaultImageTinteColor}`"                        />

                      </vue-draggable-resizable>

                      
                      <span v-else-if="zone.type == 2 && zone.isEnabledPersonalisedQrCode">
                        <QrcodeVue
                          :id="`qr-code-${zone.id}`"
                        :value="zone.text"
                          level="M"
                          render-as="canvas"
                          background="transparent"
                          :foreground="zone.fontColor ? zone.fontColor : '#' + defaultImageTinteColor"
                          gradient-type="linear"
                          :image-settings="{
                            src: '/logo.png',
                            height: 30,
                            width: 30,
                            excavate: true
                          }"
                          />
                      </span>

                      
                      <span v-else-if="zone.type != 2 ">{{ zone.text }}</span>

                    </div>
                    </div>

                      <span :class="visibleAttributeIndex == index ? '' : ''" v-else style="font-size: 100%;">{{ zone.name.replace('-', ' ') }}</span>
                    </div>

                </div>
              </div>
            </div>

          </div>



        </div>

      </div>


      <div class="row mt-4 d-print-none">
        <!-- <div class="col-6 d-print-none" v-if="isDraft">
          <b-button
            v-if="cartCount > 1"
            variant="dark"
            size="md"
            @click="sendStylesToBackend(0)"
            class="text-uppercase custom-rounded font-weight-bold"
            :disabled="currentIndex == 0"
            >
            <img  alt="" width="16px"
              style="cursor: pointer; transform: scaleX(-1);" 
              src="@/assets/icons/arrow-next.svg"
              class="pb-1 mr-1"/>
              Précédent
          </b-button>
        </div> -->

        <div class="col-12 text-right d-print-none"  v-if="isDraft" >
          <b-button
            variant="dark"
            size="md"
            @click="sendStylesToBackend(1)"
            class="text-uppercase custom-rounded font-weight-bold"
          >
            Enregistrer
            <!-- <img  alt="" width="16px"
              style="cursor: pointer;" 
              src="@/assets/icons/arrow-next.svg"
              class="pb-1 ml-1"/> -->
          </b-button>
        </div>
        <div v-else class="col-12 p-1 float-right d-print-none" > 
              <b-button variant="secondary" class="float-right" @click="printPage">
                <img  alt="" width="16px"
                  style="cursor: pointer;" 
                  src="@/assets/icons/print-white.svg"
                  class="mr-2"/> Imprimer
              </b-button>
        </div>
      </div>


      

    </div>
   <div
      v-else
      class="d-flex flex-column justify-content-center align-items-center text-center py-5 d-print-none"
      style="min-height: 25em;"
    >
      <span class="text-warning font-weight-bold font-size-16">
        Vous n'avez aucun article dans votre panier
      </span>

      <p class="text-dark font-size-16 mt-2">
        Explorez notre
        <a class="text-warning font-weight-bold" href="/sac-personnalise/">
          catalogue d'articles
        </a>
        pour trouver des produits qui vous inspirent !
      </p>
    </div>
    <!-- Print footer -->
    <div class="print-footer d-print-block d-none">
      <div class="footer-content">
        <img :src="require('@/assets/images/logo.png')" alt="Logo" class="logo" />
        <h1>APS PACKAGING<sup>®</sup></h1>
      </div>
    </div>

  </Layout>
</template>


<style scoped>
.btn-icon:hover img {
  filter: brightness(0) invert(1);
}

.btn-icon.btn-dark.active img {
  filter: brightness(0) invert(1);
}

.btn-icon img {
  transition: filter 0.2s;
}
.paperTypeButton.selected {
  background-color: #000; 
  color: white;
  border-color: #000; 
}

.word-toolbar .btn {
  border-radius: 4px;
  background-color: #f4f4f4;
  border: 1px solid #ccc;
}

.word-toolbar .btn-primary {
  background-color: #2e89ff;
  color: white;
  border-color: #2e89ff;
}

.word-toolbar select {
  min-width: 70px;
}

::v-deep .handle-tl{
    top: 0px;
    left: 0px;
}
::v-deep .handle-tm{
    top: 0px;
}
::v-deep .handle-tr{
    top: 0px;
    right: 0px;
}
::v-deep .handle-bl{
    bottom: 0px;
    left: 0px;
}
::v-deep .handle-br{
    bottom: 0px;
    right: 0px;
}
::v-deep .handle-bm{
    bottom: 0px;
}
::v-deep .handle-mr{
    right: 0px;
}
::v-deep .handle-ml{
    left: 0px;
}

.custom-rounded{
   border-radius: 5px;
}

.custom-right-rounded {
  border-radius: 5px 0 0 5px;
}
.custom-left-rounded {
  border-radius: 0 5px 5px 0;
}

.image-container {
  position: relative; 
  display: inline-block;

}

.image {
    display: block;
    width:1059px;
    height:731px
}

.custom-empty-zone {
  position: absolute;
  background: rgba(255, 255, 255, 0.7);
  border: 1px dashed black;
  text-align: center;
  font-size: 12px;
}

.custom-empty-zone-selected {

  position: absolute;
  background: rgba(255, 255, 255, 0.7);
  text-align: center;
  font-size: 12px;

  /*background-color:#ced7e9bd;
  border: 2px dashed #2E469D;*/

}


.custom-zone {
  position: absolute;
  text-align: center;
  font-size: 12px;
}


.zone-content {
  position: relative;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain; 
  /* overflow: hidden; */
  
}

.zone-image {
  width: 100%;
  height: 100%;
}

.title-zone {
  position: absolute;
  transform: translate(-50%, -50%);

  top: 28%;
  left: 31.7%;
  width: 26%;
  height: 2%;


}

.logo-zone {
  position: absolute;
  transform: translate(-50%, -50%);

  top: 41%;
  left: 31.7%;
  width: 26%;
  height: 18%;
}

.address-zone {
  position: absolute;
  transform: translate(-50%, -50%);

  top: 80%;
  left: 31.7%;
  width: 26%;
  height: 2%;
}

.client-name-zone {
  position: absolute;
  transform: translate(-50%, -50%);

  top: 85%;
  left: 31.7%;
  width: 26%;
  height: 2%;
}

.logo-back-zone {
  position: absolute;
  transform: translate(-50%, -50%);

  top: 84%;
  left: 73.7%;
  width: 24%;
  height: 3%;
}


.zone {
  position: absolute;
  transform: translate(-50%, -50%);


}

::v-deep .v-select .vs__search {
  color: #505971;
         
}

::v-deep .v-select .vs__dropdown-menu {
  background-color: #ffffff;
  border: 1px solid #ccc; 
  border-radius: 5px;     
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  font-size: 1.1em;  
  max-height: 300px; 
  /* overflow-y: auto;            */
}


.modelDesign {
  top: 100px ;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

.zone-fields {
  border-radius:3px;
  background-color:#fff;
  border: 3px solid #f8f7fa;
  box-shadow: 0 0 5px 0 rgba(0,0,0,.1);
}

.color-box {
  width: 1.7rem;
  height: 1.7rem;
  border-radius: 4px;
  border: 1px solid #ddd !important;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.color-box.selected {
  border: 2px solid !important;
}


.quantity-container {
  border-top: 1px solid #ddd;
  margin-top: 10px;
  padding-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  padding: 8px 0;
}

.quantity-label {
  font-weight: 500;
  font-size: 14px;
  color: #333;
}

.quantity-control {
  display: flex;
  align-items: center;
  background-color: #fff;
  border: 1px solid #dcdcdc;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  padding: 0 8px;
  height: 36px;
  width: 110px;
}

.icon-btn {
  width: 18px;
  height: 18px;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.icon-btn:hover {
  transform: scale(1.2);
}

.quantity-input {
  width: 70px;
  text-align: center;
  border: none;
  font-weight: 600;
  font-size: 14px;
  background: transparent;
  outline: none;
}

.quantity-input::-webkit-inner-spin-button,
.quantity-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.quantity-subtotal {
  font-weight: bold;
  font-size: 16px;
  color: #121212;
}

.image-wrapper {
  border: 2px solid transparent;
  padding: 4px;
  cursor: pointer;
  transition: border-color 0.2s ease;
  border-radius: 4px;
}

.image-wrapper:hover {
  border-color: #999;
}

.image-wrapper.selected {
  border-color: #007bff; /* Bleu Bootstrap */
}


.save-svg {
  width: 20px;
  height: 20px;
}

@media (min-width: 768px) and (max-width: 1200px) {
  .save-svg {
    width: 17px;
    height: 17px;
  }
}

.border-custom {
  border: 1px solid #ccc;
}

@media print {
  .d-print-none {
    display: none !important;
    height: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
  }



  @page {
    size: landscape; 
    margin: 5mm;
  }
  .modelDesign{
    margin: 0px !important;
    top: 0px  !important;
    zoom: 75%;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  .print-footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    text-align: center;
    border-top: 1px solid #ccc;
    background: white;
  }

  .print-footer .logo {
    height: 40px;
    vertical-align: middle;
    margin-right: 10px;
  }

  .print-footer h1 {
    display: inline-block;
    font-size: 18px;
    vertical-align: bottom;
    margin: 0;
  }
}
</style>

